import React from 'react';

const items = [
  'UGC Creation',
  'Social Media Management',
  'Brand Building',
  'Content Strategy',
  'Short-Form Video',
  'Online Presence',
];

const Marquee = () => {
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-[#1C1917]/10 bg-[#1C1917] text-[#F4F4F3] py-5 overflow-hidden w-full"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex items-center shrink-0">
            {items.map((item) => (
              <span key={`${i}-${item}`} className="flex items-center">
                <span
                  className="px-8 text-sm sm:text-base font-bold uppercase tracking-[0.15em]"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                >
                  {item}
                </span>
                <span className="text-[#AA94FF] text-xl">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
